export const getFiltersBasedOnLastLocation = (initialFilters, activeFilters, lastLocation) => {
  // TODO: Add better way to detect detail page?
  const navigatedFromDetailPage = lastLocation && lastLocation.pathname.split("/").length === 4;
  const filters = navigatedFromDetailPage ? [...new Set([...activeFilters])] : initialFilters;
  return filters;
};
